import { cn } from "@/shared/lib/utils";

interface LoadingSpinnerProps {
  message?: string;
  // Fills the screen itself, so render it bare rather than inside another
  // full-screen box; pages on proposal paper pass bg-slate-bg here.
  className?: string;
}

export function LoadingSpinner({ message = "Loading...", className }: LoadingSpinnerProps) {
  return (
    <div className={cn("min-h-screen bg-page flex items-center justify-center", className)}>
      <div className="flex flex-col items-center gap-5 text-slate-500">
        {/* Brand four-ray cross — slow rotation so remounts across page
            transitions don't read as a jarring reset. */}
        <svg
          className="animate-spin h-12 w-12"
          style={{ animationDuration: "6s" }}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="square"
          aria-hidden="true"
        >
          <path d="M12 2V22M2 12H22M4.93 4.93L19.07 19.07M19.07 4.93L4.93 19.07" />
        </svg>
        {message ? <span className="text-sm">{message}</span> : null}
      </div>
    </div>
  );
}
